export const DEFAULT_CENTER_MODE = "robust";
//# sourceMappingURL=camera-types.js.map